import { useThree, extend, useFrame } from "@react-three/fiber";
import React, { useEffect, useRef, useContext, useState } from 'react'
import * as THREE from "three";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";
import { Line } from "@react-three/drei";
import { GVarState } from '../StoreState/Gstate';
import ShowPathAnimantion from "./ShowPathAnimation";
import gsap from "gsap";
import ShowPathIcon from "./ShowPathIcon";



extend({ LineMaterial, LineGeometry });

// THREE.Cache.enabled = false

function LoadPath() {
  let g = useContext(GVarState);

  let { camera, controls } = useThree()
  const ref = useRef();
  const line2 = useRef();

  const [pointsPath, setPointsPath] = useState(null)
  const [newPointsPath, setnewPointsPath] = useState(null)
  const [showPathAnimation, setShowPathAnimation] = useState(false)
  const [totalDisatance, setTotalDisatance] = useState(null)
  const [showPath, setshowPath] = useState(false)

  // useFrame(({ clock }) => {
  //   line2.current.gapSize = clock.getElapsedTime()
  // })

  useEffect(() => {
    if (g.path.length > 0 && g.floorRootPaths[g.CurrentFloor] && g.CurrentRoots) {
            let points = [];
      let newPoints = []
      // const pointsPathCreate = new THREE.CurvePath();
      setPointsPath(null)
      setnewPointsPath(null)
      let totalDistance = 0
            Object.values(g.CurrentRoots)[g.ActiveFloor].forEach((path, index) => {
        if (g.CurrentFloor === path.a?.z && g.CurrentFloor === path.b?.z) {
          // create points
          points.push([path.a.x / 10, 1, path.a.y / 10]);
          points.push([path.b.x / 10, 1, path.b.y / 10]);
        }
      })
      // g.path.forEach((path, index) => {

      //   if (g.CurrentFloor === path.a?.z && g.CurrentFloor === path.b?.z) {
      //     // create points
      //     points.push([path.a.x / 10, 1, path.a.y / 10]);
      //     points.push([path.b.x / 10, 1, path.b.y / 10]);
      //   }
      // })


      g.floorRootPaths[g.CurrentFloor].forEach((d, i) => {
        let p = []
        d.forEach((v, i) => {
          p.push([v.a.x / 10, 1, v.a.y / 10]);
          p.push([v.b.x / 10, 1, v.b.y / 10]);

        })
        newPoints.push(p)
      })
            setnewPointsPath(newPoints)
      // set point path
      // show path
      let uniq = points.filter((value, index, self) => {
        return index === self.findIndex((t) => t[0] === value[0] && t[1] === value[1] && t[2] === value[2])
      })
      setTotalDisatance(totalDistance)
      if (uniq.length > 0) {
        setPointsPath(uniq)
      } else {
        setPointsPath(null)
      }
    } else {
      setPointsPath(null)
      setnewPointsPath(null)
    }

  }, [g.path, g.CurrentFloor, g.floorRootPaths, g.CurrentRoots, g.ActiveFloor])


  useEffect(() => {
    if (pointsPath) {
      let offset = 1.25;
      let newBox = new THREE.Box3().setFromObject(line2?.current)
      const vector = new THREE.Vector3();
      const vector1 = new THREE.Vector3();
      let xyz = newBox.getCenter(vector)
      let scale = newBox.getSize(vector1)
      xyz.scale = window.innerWidth > window.innerHeight ? 80 : (scale.x > scale.z ? scale.x + (scale.x * 50 / 100) : scale.z + (scale.z * 80 / 100))

      gsap.to(controls.target, {
        x: xyz.x, z: xyz.z, duration: 1, onComplete: () => { }
      })

      gsap.to(camera.position, {
        x: xyz.x, y: xyz.scale, z: xyz.z, duration: 1, onComplete: () => { }
      })
    }

  }, [pointsPath])


  return (
    <>

      {newPointsPath && newPointsPath?.map(d => <Line
        // ref={line2}
        points={d}
        color={"rgb(181, 81, 161)"}
        lineWidth={15}
        dashed={false}
      />)}
      {pointsPath &&
        <Line
          ref={line2}
          points={pointsPath}
          color={"rgb(181, 81, 161)"}
          lineWidth={15}
          dashed={false}
        />
      }
      {pointsPath && <ShowPathAnimantion pointsPath={pointsPath} />}

      {pointsPath && <ShowPathIcon />}
    </>
  )
}

export default LoadPath


// #3bb5fe